import React from 'react';

// Components
import RiskProfileDescription from './RiskProfileDescription';
import RiskProfileRules, { StackBarData } from './risk-profile-rules';

// Types
import Locale from '@/types/locale';
import RiskProfileItem from '@/types/risk-profile-item';
import { Profile as PartialOmniRiskProfileConfig } from '@/types/risk-profiles/omni/full-omni-risk-profile';
import { RiskProfileConfigRequirements } from '@/types/risk-profiles/risk-profiles';

interface RiskProfileCardContentProps {
  data: {
    riskProfile: PartialOmniRiskProfileConfig | RiskProfileItem;
    recommended?: boolean;
    stackBarData: StackBarData[];
    requirements?: RiskProfileConfigRequirements[];
  };
  options?: {
    hideScoreRange?: boolean;
  };
  locale: Locale;
  i18nBasePath: string;
}

const RiskProfileCardContent: React.FC<RiskProfileCardContentProps> = ({
  data: { riskProfile, recommended, stackBarData, requirements },
  options = {},
  locale,
  i18nBasePath,
}) => {
  const { hideScoreRange = false } = options;
  return (
    <>
      <RiskProfileDescription
        data={{
          riskProfile,
          recommended,
        }}
        options={{ hideScoreRange }}
        locale={locale}
        i18nBasePath={i18nBasePath}
      />
      <RiskProfileRules data={{ riskProfile, stackBarData, requirements }} i18nBasePath={i18nBasePath} locale={locale} />
    </>
  );
};

export default RiskProfileCardContent;
